import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router, UrlTree } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ApplicationService } from '../../service/application.service';
import {
  Application,
  ApplicationSelectionType,
  AssetSettlementGetApplicationAssetFn,
  CreateApplicationNoteFn,
  DeclineContractFn,
  DeleteContractFileFn,
  DigitalIdGetApplicationIndividualsFn,
  GenerateContractFn,
  GetActiveContractForApplicationFn,
  GetContractStatusFn,
  SendContractEmailsFn,
  GetRateCardDetailsFn,
  CreateNewDisbursementFn,
  UpdateDisbursementFn,
  GetDisbursementByApplicationIdFn,
  SyncDisbursementToSfFn,
  SyncBankDetailsToSfFn,
  SyncContractDetailsToSfFn,
  RemoveApplicationNoteByNoteIdFn,
  GetBillerNameFn,
  ValidateBPAYFn,
  UpdateApplicationStageInSfFn,
  GetApplicationByIdFn,
  SettleLoanFn,
  SyncPrivateSellerBankDetailsToSfFn,
  GetInstitutionNameFn,
  SyncDepositPaidToSfFn,
  GetBankDetailsFromOpportunitySfFn,
  GenerateApprovalNoticeFn,
  SendApprovalNoticeEmailFn,
  DeleteApprovalNoticeFileFn,
  RefreshBankStatementFn,
  GetUserFn,
  GetAccountDetailsFromSfFn,
  ExtractTaxInvoiceFn,
  GetLvrCalculatorValueFn,
  UpdateLvrCalculatorValueFn,
  UpdateApplicationFn,
  GetDscrCalculatorValueFn,
  UpdateDscrCalculatorValueFn,
  CreateAssetInspectionFn,
  GetAssetInspectionsForApplicationFn,
  DownloadVerimotoReportFn,
  VerimotoLenderType,
  UpdateApplicationSfFn,
  GetBankStatementsAnalysisFn,
  VerimotoInspectionTypeSelection,
  GetBsaLenderListFn,
  GetBsaExcludedLenderListFn,
  SaveBsaCalculatorFn,
  GetBsaCalculatorFn,
  RunCreditFlowFn,
  GetBasiqCustomerMappingFn, GetBasiqStatementDataForCompanyFn, RefreshBasiqConnectionsFn, GetBankStatementAndBasiqDataStatusFn,
  GetOriginatorBusinessByIdFn,
  DownloadDocumentFromAzureFn,
  GetDscrCalculatorHistoryFn,
  AddAuditLogFn,
  GetCreditWebServicesFn,
  GetApplicationCreditFlowResultFn,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
  DownloadCreditorWatchReportFn,
  UpdateCreditStatusFn,
  GetCreditAuditLogFn,
  ApplicationSelectionObject,
  GetWebServiceReportFn,
  GetDuplicatedApplicationsFn,
  DuplicatedApplication,
  DeleteWebServicesFn,
  RequestMoreInformationFn,
  WithdrawApplicationFn,
  GetApplicationDscrFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  ResendContractFn,
  AggregatorAndOriginatorListValueGetFn,
  GetUserByAccessLevelFn,
  GetApplicationSettlementsOfficerFn,
  UpdateSettlementsOfficerForApplication,
  GetAmlOfficerCandidatesFn,
  UpdateAmlOfficerForApplication,
  GetIndustryClassTitleFn,
  GetIndustryGroupTitleFn,
  GetIndustryDivisionTitleFn,
  DigitalIdUpdateIndividualKycStatusFn,
  DigitalIdSyncIndividualKycFromFrankieOneFn,
  getApplicationCustomerName,
  GetDeadletteredSalesforceJobsFn,
  RequeueDeadletteredSalesforceJobFn,
} from '@portal-workspace/grow-shared-library';
import {
  ApproveApplicationDocumentFn,
  AssetSettlementAddPpsrDetailFn,
  AssetSettlementGetApplicationPpsrInfoFn,
  AssetSettlementGetPpsrDetailsFn,
  AssetSettlementGetPpsrDocumentsFn,
  AssetSettlementRemoveApplicationAssetFn,
  AssetSettlementSearchAssetsFn,
  AssetSettlementSearchGrantorsFn,
  AssetSettlementSendAssetToSfFn,
  AssetSettlementSubmitApplicationAssetsFn,
  AssetSettlementSubmitPpsrFn,
  AssetSettlementUpdateApplicationAssetsFn,
  AssetSettlementUpdatePpsrDetailFn,
  BreadcrumbComponentEvent,
  BusinessSearchFn,
  CompleteDocumentWorklistFn,
  CreateDocumentWorklistFn,
  DeclineApplicationDocumentFn,
  DeleteApplicationDocumentFn,
  DigitalIdAddIndividualFn,
  DigitalIdSendVerificationSmsFn,
  DigitalIdUpdateApplicationIndividualDigitalIdMappingFn,
  SaveApplicationPartiesFn,
  DigitalIdVerifyOneApplicationIndividualFn,
  DownloadAllApplicationDocumentUrlFn,
  DownloadApplicationDocumentUrlFn,
  GetOriginatorByIdFn,
  ListApplicationDocumentFn,
  SaveSupplierFn,
  SearchSupplierFn,
  UpdateApplicationDocumentTagsFn,
  UpdateApplicationRequiredDocumentsFn,
  BusinessNumberSearchFn,
  displayGenerateContractButton,
  UndoApplicationDocumentFn,
  AssetSelectionComponentSearchFn,
  BusinessPricingComponentEvent,
  BusinessOverdraftPricingComponentEvent,
  ApplicationDialogService,
  InsuranceDocumentsComponent, setupUntilDestroy
} from '@portal-workspace/grow-ui-library';
import {
  navigationUrlForAssetFinance,
  navigationUrlForBusinessFinance,
  navigationUrlForInsurancePremium,
  navigationUrlForBusinessOverdraft,
  navigationUrlForApplication,
  navigationUrlForApplicationsWithQueryParams
} from '../../service/navigation-urls';
import { getUser } from '@portal-workspace/grow-ui-library';
import { UpdateApplicationDocumentFn } from '@portal-workspace/grow-ui-library';
import { GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent } from '@portal-workspace/grow-ui-library';
import { AuthService } from '../../service/auth.service';
import { tap } from 'rxjs/operators';
import { PortalHotToastService } from '@portal-workspace/grow-ui-library';
import { environment } from '../../../environments/environment';
import { PpsrService } from '../../service/ppsr.service';
import { DigitalIdService } from '../../service/digital-id.service';
import { AdminService } from '../../service/admin.service';
import {
  GetApplicationAuditLogsFn,
  GetNotesByApplicationIdFn,
  UpdateDocumentMetadataFn
} from '@portal-workspace/grow-ui-library';
import { ApplicationAuditService } from '../../service/applicationAudit.service';
import { DocusignService } from '../../service/docusign.service';
import { CorporateLoansApplicationDetailsComponent } from '@portal-workspace/grow-ui-library';

import { InsurancePremiumApplicationDetailsComponent } from '@portal-workspace/grow-ui-library';
import { ConsumerFinanceApplicationDetailsComponent } from '@portal-workspace/grow-ui-library';
import { BusinessOverdraftApplicationDetailsComponent } from '@portal-workspace/grow-ui-library';
import { BusinessFinanceApplicationDetailsComponent } from '@portal-workspace/grow-ui-library';
import { AssetFinanceApplicationDetailsComponent } from '@portal-workspace/grow-ui-library';
import { MessageBoxComponent } from '@portal-workspace/grow-ui-library';
import { SalesforceSyncFailedComponent } from '@portal-workspace/grow-ui-library';

import { RedbookService } from "../../service/redbook.service";
import { AssetPricingComponentEvent } from '@portal-workspace/grow-ui-library';
import { UntilDestroy } from "@ngneat/until-destroy";
import { firstValueFrom, Subscription } from "rxjs";
import { BasiqService } from '../../service/basiq.service';
import { IndustryService } from '../../service/industry.service';

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
  templateUrl: './application.page.html',
  styleUrls: ['./application.page.scss'],
  standalone: true,
  imports: [
    MessageBoxComponent,
    AssetFinanceApplicationDetailsComponent,
    BusinessFinanceApplicationDetailsComponent,
    BusinessOverdraftApplicationDetailsComponent,
    ConsumerFinanceApplicationDetailsComponent,
    InsurancePremiumApplicationDetailsComponent,
    CorporateLoansApplicationDetailsComponent,
    InsuranceDocumentsComponent,
    SalesforceSyncFailedComponent,
  ]
})
export class ApplicationPage implements OnInit, OnDestroy, AfterViewChecked {

  subscriptions: Subscription[] = [];

  private defaultBrowserTitle: string | null = null;

  @ViewChild(AssetFinanceApplicationDetailsComponent) assetFinanceDetails?: AssetFinanceApplicationDetailsComponent;
  @ViewChild(BusinessFinanceApplicationDetailsComponent) businessFinanceDetails?: BusinessFinanceApplicationDetailsComponent;
  @ViewChild(BusinessOverdraftApplicationDetailsComponent) businessOverdraftDetails?: BusinessOverdraftApplicationDetailsComponent;
  @ViewChild(ConsumerFinanceApplicationDetailsComponent) consumerFinanceDetails?: ConsumerFinanceApplicationDetailsComponent;
  @ViewChild(InsurancePremiumApplicationDetailsComponent) insurancePremiumDetails?: InsurancePremiumApplicationDetailsComponent;
  @ViewChild(CorporateLoansApplicationDetailsComponent) corporateLoansDetails?: CorporateLoansApplicationDetailsComponent;

  apiUrl = `${environment.api2Host}/api2`;
  bankStatementsUrl = `${environment.bankStatements}`;
  verimotoLender: VerimotoLenderType = environment.verimoto.lender;
  navigationUrlForApplication = navigationUrlForApplication;

  defaultSalesContactId = environment.GrowFinanceGroupSalesforceId;

  getApplicationPpsrInfoFn!: AssetSettlementGetApplicationPpsrInfoFn;
  removeApplicationAssetFn!: AssetSettlementRemoveApplicationAssetFn;
  searchAssetFn!: AssetSettlementSearchAssetsFn;
  submitPpsrFn!: AssetSettlementSubmitPpsrFn;
  getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  sendAssetToSfFn!: AssetSettlementSendAssetToSfFn;
  getPpsrDetailsFn!: AssetSettlementGetPpsrDetailsFn;
  addPpsrDetailFn!: AssetSettlementAddPpsrDetailFn;
  updatePpsrDetailFn!: AssetSettlementUpdatePpsrDetailFn;
  updateApplicationAssetsFn!: AssetSettlementUpdateApplicationAssetsFn;
  submitApplicationAssetsFn!: AssetSettlementSubmitApplicationAssetsFn;
  searchGrantorsFn!: AssetSettlementSearchGrantorsFn;
  getPpsrDocumentsFn!: AssetSettlementGetPpsrDocumentsFn;
  listApplicationDocumentFn!: ListApplicationDocumentFn;
  downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
  createDocumentWorklistFn!: CreateDocumentWorklistFn;
  completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  getLvrCalculatorValueFn!: GetLvrCalculatorValueFn;
  updateLvrCalculatorValueFn!: UpdateLvrCalculatorValueFn;
  getDscrCalculatorValueFn!: GetDscrCalculatorValueFn;
  updateDscrCalculatorValueFn!: UpdateDscrCalculatorValueFn;

  getOriginatorByIdFn!: GetOriginatorByIdFn;
  addIndividualFn!: DigitalIdAddIndividualFn;
  verifyOneApplicationIndividualFn!: DigitalIdVerifyOneApplicationIndividualFn;
  sendVerificationSmsFn!: DigitalIdSendVerificationSmsFn;
  getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  updateApplicationIndividualDigitalIdMappingFn!: DigitalIdUpdateApplicationIndividualDigitalIdMappingFn;
  updateIndividualKycStatusFn!: DigitalIdUpdateIndividualKycStatusFn;
  syncIndividualKycFromFrankieOneFn!: DigitalIdSyncIndividualKycFromFrankieOneFn;
  saveApplicationPartiesFn!: SaveApplicationPartiesFn;

  getBankStatementsAnalysisFn!: GetBankStatementsAnalysisFn;
  getBankStatementAndBasiqDataStatusFn!: GetBankStatementAndBasiqDataStatusFn;
  getBasiqCustomerMappingByAbnFn!: GetBasiqCustomerMappingFn;
  getBasiqStatementDataForCompanyFn!: GetBasiqStatementDataForCompanyFn;
  refreshBasiqConnectionsFn!: RefreshBasiqConnectionsFn;
  createApplicationNoteFn!: CreateApplicationNoteFn;
  removeApplicationNoteByNoteIdFn !: RemoveApplicationNoteByNoteIdFn;
  searchSupplierFn!: SearchSupplierFn;
  saveSupplierFn!: SaveSupplierFn;
  businessSearchFn!: BusinessSearchFn;
  onBreadcrumbEventFn = this.onBreadcrumbEvent.bind(this);
  uploadApplicationDocumentFn: UpdateApplicationDocumentFn;
  getRatecardDetailsFn: GetRateCardDetailsFn;
  getUsersInCompanyFn: GetUsersByOriginatorBusinessIdFunc;
  getUserByAccessLevelFn: GetUserByAccessLevelFn;
  getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  getAmlOfficerCandidatesFn!: GetAmlOfficerCandidatesFn;
  getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  assetSettlementSearchAssetsFn!: AssetSettlementSearchAssetsFn;
  sendContractEmailsFn!: SendContractEmailsFn;
  updateDocumentMetadataFn!: UpdateDocumentMetadataFn;
  getContractStatusFn!: GetContractStatusFn;
  generateContractFn!: GenerateContractFn;
  deleteContractFileFn!: DeleteContractFileFn;
  getActiveContractForApplicationFn!: GetActiveContractForApplicationFn;
  declineContractFn!: DeclineContractFn;
  createNewDisbursementFn!: CreateNewDisbursementFn;
  updateDisbursementFn!: UpdateDisbursementFn;
  getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  syncDisbursementToSfFn!: SyncDisbursementToSfFn;
  syncBankDetailsToSfFn!: SyncBankDetailsToSfFn;
  syncDepositPaidToSfFn!: SyncDepositPaidToSfFn;
  syncPrivateSellerBankDetailsToSfFn!: SyncPrivateSellerBankDetailsToSfFn;
  syncContractDetailsToSfFn!: SyncContractDetailsToSfFn;
  businessNumberSearchFn!: BusinessNumberSearchFn
  getBillerNameFn!: GetBillerNameFn;
  validateBpayFn!: ValidateBPAYFn;
  updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  getApplicationByIdFn!: GetApplicationByIdFn;
  getInstitutionNameFn!: GetInstitutionNameFn;
  getBankDetailsFromOpportunitySfFn!: GetBankDetailsFromOpportunitySfFn;
  settleLoanFn!: SettleLoanFn;
  generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  refreshBankStatementFn!: RefreshBankStatementFn;
  getUserFn!: GetUserFn;

  getAccountDetailsFromSfFn!: GetAccountDetailsFromSfFn;
  extractTaxInvoiceFn!: ExtractTaxInvoiceFn;
  updateApplicationFn!: UpdateApplicationFn;
  updateApplicationSfFn!: UpdateApplicationSfFn;
  createAssetInspectionFn!: CreateAssetInspectionFn;
  getAssetInspectionsForApplicationFn!: GetAssetInspectionsForApplicationFn;
  downloadVerimotoReportFn!: DownloadVerimotoReportFn;
  assetSearchFn!: AssetSelectionComponentSearchFn;
  downloadDocumentFromAzureFn!: DownloadDocumentFromAzureFn;
  getBsaLenderListFn!: GetBsaLenderListFn;
  getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  saveBsaCalculatorFn!: SaveBsaCalculatorFn;
  getBsaCalculatorFn!: GetBsaCalculatorFn;
  runCreditFlowFn!: RunCreditFlowFn;
  getCreditWebServicesFn!: GetCreditWebServicesFn;
  getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  getHistoricalContractsFn!: GetHistoricalContractsFn;
  getPismoContractsFn!: GetPismoContractsFn;
  downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  updateCreditStatusFn!: UpdateCreditStatusFn;
  updateCreditOfficerFn!: UpdateCreditOfficerFn;
  getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  getCreditAuditLogFn!: GetCreditAuditLogFn;
  getDscrCalculatorHistoryFn!: GetDscrCalculatorHistoryFn;
  getOriginatorBusinessByIdFn!: GetOriginatorBusinessByIdFn;
  addAuditLogFn!: AddAuditLogFn;
  getWebServiceReportFn!: GetWebServiceReportFn;
  getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  deleteWebServicesFn!: DeleteWebServicesFn;
  requestMoreInformationFn!: RequestMoreInformationFn;
  withdrawApplicationFn!: WithdrawApplicationFn;
  getApplicationDscrFn!: GetApplicationDscrFn;
  resendContractFn!: ResendContractFn;
  getIndustryDivisionTitleFn!: GetIndustryDivisionTitleFn;
  getIndustryGroupTitleFn!: GetIndustryGroupTitleFn;
  getIndustryClassTitleFn!: GetIndustryClassTitleFn;
  getDeadletteredSalesforceJobsFn!: GetDeadletteredSalesforceJobsFn;
  requeueDeadletteredSalesforceJobFn!: RequeueDeadletteredSalesforceJobFn;

  application!: Application;
  initialApplicationSelectionType: ApplicationSelectionType = 'app';
  allowContractGeneration: boolean = false;
  loggedInUser = getUser();
  verimotoAssetInspectionTypes: VerimotoInspectionTypeSelection[] = environment.verimoto.verimotoInspectionTypes;

  getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;

  queryParams: Params = {};

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private ppsrService: PpsrService,
    private portalHotToastService: PortalHotToastService,
    private applicationService: ApplicationService,
    private digitalIdService: DigitalIdService,
    private changeDetectorRef: ChangeDetectorRef,
    private auditService: ApplicationAuditService,
    private docusignService: DocusignService,
    private redbookService: RedbookService,
    private basiqService: BasiqService,
    private industryService: IndustryService,
    private adminService: AdminService,
    private dialogService: ApplicationDialogService,
    private titleService: Title) {

    this.assetSearchFn = this.redbookService.assetSearchFn;
    this.getApplicationPpsrInfoFn = this.ppsrService.getApplicationPpsrInfoFn;
    this.removeApplicationAssetFn = this.ppsrService.removeApplicationAssetFn;
    this.searchAssetFn = this.ppsrService.searchAssetsFn;
    this.submitPpsrFn = this.ppsrService.submitPpsrFn;
    this.getApplicationAssetFn = this.ppsrService.getApplicationAssetFn;
    this.sendAssetToSfFn = this.ppsrService.sendAssetToSfFn;
    this.getPpsrDetailsFn = this.ppsrService.getPpsrDetailsFn;
    this.addPpsrDetailFn = this.ppsrService.addPpsrDetailFn;
    this.updatePpsrDetailFn = this.ppsrService.updatePpsrDetailFn;
    this.updateApplicationAssetsFn = this.ppsrService.updateApplicationAssetsFn;
    this.submitApplicationAssetsFn = this.ppsrService.submitApplicationAssetsFn;
    this.searchGrantorsFn = this.ppsrService.searchGrantorsFn;
    this.getPpsrDocumentsFn = this.ppsrService.getPpsrDocumentsFn;

    this.getBankStatementsAnalysisFn = this.applicationService.getBankStatementsAnalysisFn;
    this.getBankStatementAndBasiqDataStatusFn = this.applicationService.getBankStatementAndBasiqDataStatusFn;
    this.getBasiqCustomerMappingByAbnFn = this.applicationService.getBasiqCustomerMappingByAbnFn;
    this.getBasiqStatementDataForCompanyFn = this.applicationService.getBasiqStatementDataForCompanyFn;
    this.refreshBasiqConnectionsFn = this.basiqService.refreshBasiqConnectionsFn;
    this.uploadApplicationDocumentFn = this.applicationService.uploadApplicationDocumentToAzureStorageFn;
    this.getRatecardDetailsFn = this.applicationService.getRatecardDetailsFn;
    this.getUsersInCompanyFn = this.authService.getUsersInCompanyFn;
    this.getUserByAccessLevelFn = this.authService.getUserByAccessLevelFn;
    this.getApplicationSettlementsOfficerFn = this.applicationService.getApplicationSettlementsOfficerFn;
    this.getAmlOfficerCandidatesFn = this.applicationService.getAmlOfficerCandidatesFn;
    this.searchSupplierFn = this.ppsrService.searchSupplierFn;
    this.businessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.saveSupplierFn = this.ppsrService.saveSupplierFn;
    this.businessSearchFn = this.applicationService.businessSearchFn;
    this.listApplicationDocumentFn = this.applicationService.listApplicationDocumentFn;
    this.downloadApplicationDocumentUrlFn = this.applicationService.downloadApplicationDocumentUrlFn;
    this.downloadAllApplicationDocumentUrlFn = this.applicationService.downloadAllApplicationDocumentUrlFn;
    this.approveApplicationDocumentFn = this.applicationService.approveApplicationDocumentFn;
    this.declineApplicationDocumentFn = this.applicationService.declineApplicationDocumentFn;
    this.undoApplicationDocumentFn = this.applicationService.undoApplicationDocumentFn;
    this.deleteApplicationDocumentFn = this.applicationService.deleteApplicationDocumentFn;
    this.updateApplicationDocumentTagsFn = this.applicationService.updateDocumentTagsFn;
    this.updateApplicationRequiredDocumentsFn = this.applicationService.updateApplicationRequiredDocumentsFn;

    this.createDocumentWorklistFn = this.applicationService.createDocumentWorklistFn;
    this.completeDocumentWorklistFn = this.applicationService.completeDocumentWorklistFn;
    this.getLvrCalculatorValueFn = this.applicationService.getLvrCalculatorValueFn;
    this.updateLvrCalculatorValueFn = this.applicationService.updateLvrCalculatorValueFn;
    this.getDscrCalculatorValueFn = this.applicationService.getDscrCalculatorValueFn;
    this.updateDscrCalculatorValueFn = this.applicationService.updateDscrCalculatorValueFn;

    this.getOriginatorByIdFn = this.adminService.getOriginatorByIdFn;
    this.addIndividualFn = this.digitalIdService.addIndividualFn;
    this.verifyOneApplicationIndividualFn = this.digitalIdService.verifyOneApplicationIndividualFn;
    this.sendVerificationSmsFn = this.digitalIdService.sendVerificationSmsFn;
    this.getApplicationIndividualsFn = this.digitalIdService.getApplicationIndividualsFn;
    this.updateApplicationIndividualDigitalIdMappingFn = this.digitalIdService.updateApplicationIndividualDigitalIdMappingFn;
    this.saveApplicationPartiesFn = this.digitalIdService.saveApplicationPartiesFn;
    this.updateIndividualKycStatusFn = this.digitalIdService.updateIndividualKycStatus.bind(this.digitalIdService);
    this.syncIndividualKycFromFrankieOneFn = this.digitalIdService.syncIndividualKycFromFrankieOneFn;

    this.createApplicationNoteFn = this.ppsrService.createNoteFn;
    this.removeApplicationNoteByNoteIdFn = this.ppsrService.removeApplicationNoteByNoteIdFn;
    this.getApplicationAuditLogsFn = this.auditService.getApplicationAuditLogsFn;
    this.getNotesByApplicationIdFn = this.ppsrService.getNotesByApplicationIdFn;
    this.sendContractEmailsFn = this.docusignService.sendContractEmailsFn;
    this.updateDocumentMetadataFn = this.applicationService.updateDocumentMetadataFn;
    this.getContractStatusFn = this.docusignService.getContractStatusFn;
    this.generateContractFn = this.docusignService.generateContractFn;
    this.deleteContractFileFn = this.docusignService.deleteContractFileFn;
    this.getActiveContractForApplicationFn = this.docusignService.getActiveContractForApplicationFn;
    this.declineContractFn = this.docusignService.declineContractFn;
    this.createNewDisbursementFn = this.applicationService.createNewDisbursementFn;
    this.updateDisbursementFn = this.applicationService.updateDisbursementFn;
    this.getDisbursementByApplicationIdFn = this.applicationService.getDisbursementByApplicationIdFn;
    this.syncDisbursementToSfFn = this.applicationService.syncDisbursementToSfFn;
    this.syncBankDetailsToSfFn = this.applicationService.syncBankDetailsToSfFn;
    this.syncPrivateSellerBankDetailsToSfFn = this.applicationService.syncPrivateSellerBankDetailsToSfFn;
    this.syncDepositPaidToSfFn = this.applicationService.syncDepositPaidToSfFn;
    this.syncContractDetailsToSfFn = this.docusignService.syncContractDetailsToSfFn;
    this.getBillerNameFn = this.applicationService.getBillerNameFn;
    this.validateBpayFn = this.applicationService.validateBpayFn;
    this.updateApplicationStageFn = this.applicationService.updateApplicationStageFn;
    this.getApplicationByIdFn = this.applicationService.getApplicationByIdFn;
    this.settleLoanFn = this.applicationService.settleLoanFn;
    this.getInstitutionNameFn = this.applicationService.getInstitutionNameFn;
    this.getBankDetailsFromOpportunitySfFn = this.applicationService.getBankDetailsFromOpportunitySfFn;
    this.generateApprovalNoticeFn = this.applicationService.generateApprovalNoticeFn;
    this.sendApprovalNoticeEmailFn = this.applicationService.sendApprovalNoticeEmailFn;
    this.deleteApprovalNoticeFileFn = this.applicationService.deleteApprovalNoticeFileFn;
    this.refreshBankStatementFn = this.applicationService.refreshBankStatementFn;
    this.getUserFn = this.authService.getUserFn;
    this.getAccountDetailsFromSfFn = this.applicationService.getAccountDetailsFromSfFn;
    this.extractTaxInvoiceFn = this.applicationService.extractTaxInvoiceFn;
    this.updateApplicationFn = this.applicationService.updateApplicationFn;
    this.updateApplicationSfFn = this.applicationService.updateApplicationSfFn;
    this.createAssetInspectionFn = this.applicationService.createAssetInspectionFn;
    this.getAssetInspectionsForApplicationFn = this.applicationService.getAssetInspectionsForApplicationFn;
    this.downloadVerimotoReportFn = this.applicationService.downloadVerimotoReportFn;
    this.downloadDocumentFromAzureFn = this.applicationService.downloadDocumentFromAzureFn;
    this.getBsaLenderListFn = this.applicationService.getBsaLenderListFn;
    this.getBsaExcludedLenderListFn = this.applicationService.getBsaExcludedLenderListFn;
    this.saveBsaCalculatorFn = this.applicationService.saveBsaCalculatorFn;
    this.getBsaCalculatorFn = this.applicationService.getBsaCalculatorFn;
    this.runCreditFlowFn = this.applicationService.runCreditFlowFn;
    this.getCreditWebServicesFn = this.applicationService.getApplicationWebServicesFn;
    this.getApplicationCreditFlowResultFn = this.applicationService.getApplicationCreditFlowResultFn;
    this.getHistoricalContractsFn = this.applicationService.getHistoricalContractsFn;
    this.getPismoContractsFn = this.applicationService.getPismoContractsFn;
    this.downloadCreditorWatchReportFn = this.applicationService.downloadCreditorWatchReportFn;
    this.updateCreditStatusFn = this.applicationService.updateCreditStatusFn;
    this.updateCreditOfficerFn = this.applicationService.updateCreditOfficerFn;
    this.getActiveCreditUsersFn = this.applicationService.getActiveCreditUsers;
    this.getCreditAuditLogFn = this.applicationService.getCreditAuditLogFn;
    this.getDscrCalculatorHistoryFn = this.applicationService.getDscrCalculatorHistoryFn;
    this.getOriginatorBusinessByIdFn = this.applicationService.getOriginatorBusinessByIdFn;
    this.addAuditLogFn = this.ppsrService.addAuditLogFn;
    this.getWebServiceReportFn = this.applicationService.getWebServiceReportFn;
    this.getDuplicatedApplicationsFn = this.applicationService.getDuplicatedApplicationsFn;
    this.deleteWebServicesFn = this.applicationService.deleteWebServicesFn;
    this.requestMoreInformationFn = this.applicationService.requestMoreInformationFn;
    this.withdrawApplicationFn = this.applicationService.withdrawApplicationFn;
    this.getApplicationDscrFn = this.applicationService.getApplicationDscrFn;
    this.resendContractFn = this.docusignService.resendContractFn;
    this.getAggregatorsAndOriginatorsFn = this.adminService.getAggregatorsAndOriginatorsFn;
    this.getIndustryDivisionTitleFn = this.industryService.getIndustryDivisionTitleFn;
    this.getIndustryGroupTitleFn = this.industryService.getIndustryGroupTitleFn;
    this.getIndustryClassTitleFn = this.industryService.getIndustryClassTitleFn;
    this.getDeadletteredSalesforceJobsFn = this.applicationService.getDeadletteredSalesforceJobsFn;
    this.requeueDeadletteredSalesforceJobFn = this.applicationService.requeueDeadletteredSalesforceJobFn;
  }

  async ngOnInit() {
    setupUntilDestroy(this);
    this.initialApplicationSelectionType = this.activatedRoute.snapshot.params['innerTabs'];
    this.queryParams = this.activatedRoute.snapshot.queryParams ?? {};
    this.application = (this.activatedRoute.snapshot.data as any).application;

    this.updateBrowserTitleFromApplication();

    this.allowContractGeneration = displayGenerateContractButton(this.loggedInUser, environment.production);
    if (this.application && this.application.Status === 'Draft') {
      const applicationId = this.application.ApplicationId;
      switch (this.application.ApplicationType) {
        case 'AssetFinance':
          const urlTree = navigationUrlForAssetFinance(this.router, this.application.AppInfo.productType, this.application.AppInfo?.isSwitchToEasyDoc, applicationId);
          await this.router.navigateByUrl(urlTree);
          break;
        case 'BusinessLoans':
          await this.router.navigate(navigationUrlForBusinessFinance(applicationId));
          break;
        case 'BusinessOverdraft':
          await this.router.navigate(navigationUrlForBusinessOverdraft(applicationId));
          break;
        case 'InsurancePremium':
          await this.router.navigate(navigationUrlForInsurancePremium(applicationId));
          break;
      }
    } else if (!this.application) {
      this.onNavigateToApplications();
    }
  }

  ngOnDestroy() {
    if (this.defaultBrowserTitle !== null) {
      this.titleService.setTitle(this.defaultBrowserTitle);
      this.defaultBrowserTitle = null;
    }
  }

  private activeDetailsComponent():
    | AssetFinanceApplicationDetailsComponent
    | BusinessFinanceApplicationDetailsComponent
    | BusinessOverdraftApplicationDetailsComponent
    | ConsumerFinanceApplicationDetailsComponent
    | InsurancePremiumApplicationDetailsComponent
    | CorporateLoansApplicationDetailsComponent
    | undefined {
    return this.assetFinanceDetails
      ?? this.businessFinanceDetails
      ?? this.businessOverdraftDetails
      ?? this.consumerFinanceDetails
      ?? this.insurancePremiumDetails
      ?? this.corporateLoansDetails;
  }

  hasUnsavedKycChanges(): boolean {
    return !!this.activeDetailsComponent()?.hasUnsavedKycChanges();
  }

  // Browser refresh / close / tab close — browsers only allow a native leave prompt here.
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    if (this.hasUnsavedKycChanges()) {
      event.preventDefault();
      event.returnValue = true;
    }
  }

  // In-app navigation away from the application page (menu, breadcrumb, etc.).
  // Same-application tab URL updates are already guarded by the in-page KYC tab handler.
  async canDeactivate(currentUrl?: string, nextUrl?: string): Promise<boolean> {
    if (this.isSameApplicationNavigation(currentUrl, nextUrl)) {
      return true;
    }
    const details = this.activeDetailsComponent();
    if (!details?.hasUnsavedKycChanges()) {
      return true;
    }
    const leave = await firstValueFrom(
      this.dialogService.openUnsavedChangesDialog(details.unsavedKycChangeLabels()).afterClosed(),
    );
    return !!leave;
  }

  private isSameApplicationNavigation(currentUrl?: string, nextUrl?: string): boolean {
    if (!currentUrl || !nextUrl) {
      return false;
    }
    const currentAppId = this.applicationIdFromUrl(currentUrl);
    const nextAppId = this.applicationIdFromUrl(nextUrl);
    return !!currentAppId && currentAppId === nextAppId;
  }

  private applicationIdFromUrl(url: string): string | null {
    const match = url.match(/\/application\/([^\/?#]+)/);
    return match?.[1] ?? null;
  }

  private updateBrowserTitleFromApplication() {
    if (!this.application) {
      return;
    }
    const customerName = getApplicationCustomerName(this.application);
    if (!customerName) {
      return;
    }
    if (this.defaultBrowserTitle === null) {
      this.defaultBrowserTitle = this.titleService.getTitle();
    }
    this.titleService.setTitle(customerName);
  }

  async onApplicationSelectionType(selectionObject: ApplicationSelectionObject) {
    await this.router.navigate(
      this.navigationUrlForApplication(String(this.application.ApplicationId), selectionObject.selection, selectionObject.innerTabParam),
      { replaceUrl: true, onSameUrlNavigation: 'ignore' });
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }


  async onBreadcrumbEvent(evt: BreadcrumbComponentEvent) {
    // NOTE:
    // WEB-5403: You get here from application listing page, so the list cached already has this application, no
    //           need to reload when going back to the listing page
    await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, {
      ...(this.queryParams ?? {}),
      reload: false
    }));
  }



  onApplicationDetailsEvent($event: UserSelectionComponentEvent & { type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer' }) {
    if ($event && $event.value) {
      const data = $event.value;

      if ($event.type == 'submitter') {
        const submitterUserId = $event.value.UserId;
        this.subscriptions.push(this.applicationService.updateApplicationSubmitter(this.application.ApplicationId, submitterUserId, data, this.application.AppInfo.BrokerSalesforceID, this.application.AppInfoSalesforceID).pipe(
          this.portalHotToastService.spinnerObservable(),
          this.portalHotToastService.snackBarObservable(`Submitter updated`),
          tap(r => {
            this.reloadApplication(true);
          })
        ).subscribe());
      }
      else if ($event.type == 'additional-correspondent') {
        this.subscriptions.push(this.applicationService.updateApplicationAdditionalCorrespondent(this.application.ApplicationId, data).pipe(
          this.portalHotToastService.spinnerObservable(),
          this.portalHotToastService.snackBarObservable(`Additional correspondent updated`),
          tap(r => {
            this.reloadApplication(true);
          })
        ).subscribe());
      }
      else if ($event.type == 'broker') {
        this.subscriptions.push(this.applicationService.updateApplicationBroker(this.application.ApplicationId, data, this.application.AppInfoSalesforceID).pipe(
          this.portalHotToastService.spinnerObservable(),
          this.portalHotToastService.snackBarObservable(`Broker updated`),
          tap(r => {
            this.reloadApplication(true);
          })
        ).subscribe());

      }
      else if ($event.type == 'sales-contact') {
        const salesforceId = this.application.AppInfoSalesforceID ?? "";
        const salesContactUserId = $event.value.UserId;
        this.subscriptions.push(this.applicationService.updateApplicationSalesContact(this.application.ApplicationId, salesContactUserId, data, salesforceId).pipe(
          this.portalHotToastService.spinnerObservable(),
          this.portalHotToastService.snackBarObservable(`Sales contact updated`),
          tap(r => {
            this.reloadApplication(true);
          })
        ).subscribe());
      }

      else if ($event.type == 'credit-officer') {
        const updatePayload = {
          applicationId: this.application.ApplicationId,
          creditOfficerId: data.UserId
        };
        this.subscriptions.push(this.applicationService.updateCreditOfficerFn(updatePayload).pipe(
          this.portalHotToastService.spinnerObservable(),
          this.portalHotToastService.snackBarObservable(`Credit officer updated`),
          tap(r => {
            this.reloadApplication(true);
          })
        ).subscribe());

      }
      else if ($event.type == 'settlement') {
        const user = $event.value;
        const updatePayload: UpdateSettlementsOfficerForApplication = {
          settlmentUserId: user.UserId ?? null,
          applicationId: this.application.ApplicationId,
        };
        this.subscriptions.push(
          this.applicationService.updateSettlementsOfficerFn(updatePayload).pipe(
            this.portalHotToastService.spinnerObservable(),
            this.portalHotToastService.snackBarObservable(`Settlement updated`),
            tap(r => {
              this.reloadApplication(true);
            })
          ).subscribe());
      }
      else if ($event.type == 'aml-officer') {
        // The "Unassigned" item parses to NaN, which clears the officer.
        const userId = $event.value.UserId;
        const updatePayload: UpdateAmlOfficerForApplication = {
          applicationId: this.application.ApplicationId,
          amlOfficerUserId: Number.isInteger(userId) && userId > 0 ? userId : null,
        };
        this.subscriptions.push(
          this.applicationService.updateAmlOfficerFn(updatePayload).pipe(
            this.portalHotToastService.spinnerObservable(),
            this.portalHotToastService.snackBarObservable(updatePayload.amlOfficerUserId ? `AML officer updated` : `AML officer cleared`),
            tap(r => {
              this.reloadApplication(true);
            })
          ).subscribe());
      }
    }
  }

  async onNavigateToApplications() {
    // WEB-5403:
    await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, {
      ...(this.queryParams ?? {}),
      reload: true
    }));

  }

  async onAssetPricingEvents(event: AssetPricingComponentEvent) {
    switch (event.type) {
      case "asset-pricing-saved": {
        this.reloadApplication(false);
        break;
      }
    }
  }

  async onBusinessPricingEvents(event: BusinessPricingComponentEvent) {
    switch (event.type) {
      case "business-pricing-saved": {
        this.reloadApplication(false);
        break;
      }
    }
  }

  async onBusinessOverdraftPricingEvents(event: BusinessOverdraftPricingComponentEvent) {
    switch (event.type) {
      case "business-overdraft-pricing-saved": {
        this.reloadApplication(false);
        break;
      }
    }
  }

  reloadApplication(reload: boolean) {
    this.subscriptions.push(this.applicationService.getApplicationById(this.application.ApplicationId).pipe(
      tap(r => {
        if (r.status) {
          this.application = r.payload;
        }
      })
    ).subscribe());
    if (reload) {
      window.location.reload();
    }
  }

  async onClickApplicationEvent(application: DuplicatedApplication) {
    const stage = application.AppInfo.StageName ?? 'Draft';
    const applicationId = application.ApplicationId;
    let urlTree: UrlTree | null = null;
    if (stage === 'Draft') {
      switch (application.ApplicationType) {
        case 'AssetFinance':
          urlTree = navigationUrlForAssetFinance(this.router, application.AppInfo.productType, application.AppInfo?.isSwitchToEasyDoc, applicationId);
          break;
        case 'BusinessLoans':
          urlTree = this.router.createUrlTree(navigationUrlForBusinessFinance(applicationId));
          break;
        case 'BusinessOverdraft':
          urlTree = this.router.createUrlTree(navigationUrlForBusinessOverdraft(applicationId));
          break;
        case 'InsurancePremium':
          urlTree = this.router.createUrlTree(navigationUrlForInsurancePremium(applicationId));
          break;
      }
    } else {
      urlTree = this.router.createUrlTree(
        navigationUrlForApplication(String(application.ApplicationId), 'app', undefined, undefined)
      );
    }
    if (urlTree) {
      window.open(this.router.serializeUrl(urlTree), '_blank');
    }
  }

  async refreshCreditTab(application: Application) {
    window.location.reload();
  }
}
